import { render, staticRenderFns } from "./CapSensitivityTest.vue?vue&type=template&id=2ba2b37e&"
import script from "./CapSensitivityTest.vue?vue&type=script&lang=js&"
export * from "./CapSensitivityTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports